/** 云闪付活动页 */
<template>
  <div class="coupon-wrapper">
    <div class="banner-box">
      <img
        src="https://oss.aqdpay.com/appweb/cmbCreditCard/cloudFlashPaymentActive/banner.png"
        alt=""
        width="100%"
      />
      <div @click="goIntro" class="intro-tip">查看云闪付新用户注册流程</div>
    </div>
    <div class="main-box">
      <div class="activity-content">
        <img
          src="https://oss.aqdpay.com/appweb/cmbCreditCard/cloudFlashPaymentActive/1.png"
          alt=""
        />
        <div class="btn-box">
          <div class="btn-item" @click="goDrug">医保城、国风药店线上购药</div>
          <div class="btn-item" @click="goUseOne">乘车码、琴岛通卡充值</div>
          <div class="btn-item" @click="goUseThree">隧e通账户充值</div>
        </div>
      </div>
      <div class="pay-box">
        <div class="btn-item" @click="goRules">点击查看更多活动细则</div>
        <img
          src="https://oss.aqdpay.com/appweb/cmbCreditCard/cloudFlashPaymentActive/2.png"
          alt=""
          width="100%"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { setStore } from '@/utils/index'
export default {
  data () {
    return {}
  },
  mounted () {
    const token = this.$route.query.token
    if (token) {
      console.log(token)
      setStore('token', token)
    } else {
      this.goLogin()
    }
  },
  methods: {
    goLogin () {
      /* eslint-disable */
      dsBridge.call("callLogin", function(res) {
        const token = res;
        if (res) {
          setStore("token", token);
        }
      });
    },
    goIntro() {
      this.$router.push("/drugBindIntro");
    },
    // 去医保城
    goDrug() {
      dsBridge.call("callNativeView", {
        androidGoPage: "/drug/DrugHomeActivity",
        iosGoPage: "GXGYHomeViewController"
      });
    },
    // 去二维码充值
    goUseOne() {
      const data = {
        androidGoPage: "/ReactNative/QDTQRCodeActivity",
        iosGoPage: "QDTViewController",
        appType: 0,
        appStartUrl: "QrCodeMainPage"
      };
      /* eslint-disable */
      dsBridge.call("callNativeViewLifeCycle", {
        ...data
      });
    },
    // 去实体卡充值
    goUseTwo() {
      const data = {
        androidGoPage: "/ReactNative/QDTHomeActivity",
        iosGoPage: "QDTViewController",
        appType: 0,
        appStartUrl: "NfcReadCardBalancePage"
      };
      /* eslint-disable */
      if (this.getType()) {
        dsBridge.call("callNativeViewLifeCycle", {
          ...data
        });
      }
    },
    // 去隧e通充值
    goUseThree() {
      const data = {
        androidGoPage: "/ReactNative/QDTHomeActivity",
        iosGoPage: "QDTViewController",
        appType: 0,
        appStartUrl: "SytBalance"
      };
      /* eslint-disable */
      dsBridge.call("callNativeViewLifeCycle", {
        ...data
      });
    },
    // 查看更多活动细则
    goRules() {
      this.$router.push({
        path: "/cloudPayIntro"
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.coupon-wrapper {
  box-sizing: border-box;
  min-height: 100vh;
  padding-bottom: 45px;
  background: #ed6b55;
  img {
    display: block;
    width: 100%;
  }
}

.main-box {
  width: 90%;
  margin: 0 5%;
}

.banner-box {
  position: relative;
  margin-bottom: 5%;
}

.intro-tip {
  position: absolute;
  bottom: 0;
  width: 100%;
  text-align: center;
  color: #ffffff;
  font-size: 14px;
  text-decoration: underline;
}

.activity-content {
  position: relative;
  margin-bottom: 5%;
}

.btn-box {
  position: absolute;
  bottom: 20px;
  width: 100%;
  height: 46%;

  .btn-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 29%;
    margin-bottom: 10px;
    color: transparent;
  }
}

.pay-box {
  position: relative;

  .btn-item {
    position: absolute;
    bottom: 70px;
    width: 100%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: transparent;
  }
}
</style>
